// React imports
import React, { useEffect, useState } from 'react';

// Material UI imports
import { Box, IconButton, TextField, InputAdornment } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';

export interface IColumnWidthProps {
  onChange: (value: number) => void;
}

export const ColumnWidth = ({onChange}: IColumnWidthProps) => {
  const [value, setValue] = useState(6);

  const handleIncrement = () => {
    setValue(prev => prev + 1);
  };

  const handleDecrement = () => {
    setValue(prev => Math.max(0, prev - 1)); // Prevent negative values
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number.parseInt(event.target.value) || 0;
    setValue(Math.max(0, newValue));
  };

  useEffect(() => {
    onChange(value);
  }, [value]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 4 }}>
      <TextField
        value={value}
        onChange={handleInputChange}
        name='custom_width'
        size="small"
        sx={{
          width: '120px',
          '& .MuiOutlinedInput-root': {
            paddingLeft: 0,
            paddingRight: 0,
            '& input': {
              textAlign: 'center',
              padding: '8px 4px',
            }
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconButton
                onClick={handleDecrement}
                size="small"
                sx={{
                  marginLeft: '-4px',
                  borderRadius: '4px 0 0 4px',
                  border: 'none',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)'
                  }
                }}
              >
                <Remove fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={handleIncrement}
                size="small"
                sx={{
                  marginRight: '-4px',
                  borderRadius: '0 4px 4px 0',
                  border: 'none',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)'
                  }
                }}
              >
                <Add fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        inputProps={{
          type: 'number',
          min: 0,
        }}
      />
      
      <Box sx={{ ml: 2, color: 'text.secondary' }}>
        Current value: {value}
      </Box>
    </Box>
  );
};

export default ColumnWidth;